var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",style:({
    width: _vm.cssProp(716 * _vm.scale),
    height: _vm.cssProp(625 * _vm.scale),
    pointerEvents: 'none'
  })},[_c('div',{style:({ scale: _vm.scale })},_vm._l((_vm.components),function(component,position){return _c('div',{key:position},[(
          component.selected && _vm.showIngredientComposition(component.selected)
        )?_c('ingredient-image-composition',{attrs:{"product":component.selected,"compositionImageGroups":_vm.compositionImageGroups(component.selected),"scale":_vm.scale}}):(component.selected)?_c('img',{staticClass:"image",style:({
          top: _vm.cssProp(component.top - 400, '0'),
          left: _vm.cssProp(component.left - 20, '0'),
          width: _vm.cssProp(component.width, 'auto'),
          height: _vm.cssProp(component.height, 'auto'),
          zIndex: component.zIndex + 1
        }),attrs:{"src":_vm.componentImage(component)}}):_c('img',{staticClass:"image",style:({
          top: _vm.cssProp(component.top - 400, '0'),
          left: _vm.cssProp(component.left - 20, '0'),
          width: _vm.cssProp(component.width, 'auto'),
          height: _vm.cssProp(component.height, 'auto'),
          zIndex: component.zIndex + 1
        }),attrs:{"src":component.placeholder}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }